goog.require('el8.uiwidget.base');
goog.require('el8.appanalytics.reportsMgr');
goog.require('el8.app.setup');
goog.require('el8.data.practiceUsers');

var el8 = el8 || {};
if(!el8.main) { el8.main = {}; }
el8.main.appanalytics = {};

el8.main.appanalytics.init = function(spec) {

    spec['layout'] = {innerContainerSelector: '#analytics-container'};
    el8.app.setup(spec);

    el8React.configureStore(spec);
    el8React.renderFindChartHeaderButton('react-chartnav');

    el8.data.practiceUsers.load();
    $('#analytics-details').show();

    $(document).on('click', '.report-title', function(event) {
        var name = $(this).attr('_section');
        el8.appanalytics.reportsMgr.showTab(name);
    });

    el8.appanalytics.reportsMgr.init(spec.cqm_data['cqm_reporting_periods']['custom']);
};
